<script>
  import { push } from 'svelte-spa-router';
  import { API_ROOT, authApi } from '../stores/api.js';
  import { safeOAuthReturnTo } from '../lib/oauthReturnTo.js';
  import { authStore, logout } from '../stores/auth.js';
  import { _ } from '../lib/i18n.js';
  import AuthCard from '../components/AuthCard.svelte';
  import AuthNotice from '../components/AuthNotice.svelte';

  let isLoading = false;
  let sent = false;
  let error = '';

  $: email = $authStore.user?.email || '';

  // The INWD login holds an unverified customer here with its challenge in the
  // pre-hash query; signing in again through #/login, which keeps that query,
  // goes back to it.
  const resumesConsole = typeof window !== 'undefined'
    && Boolean(safeOAuthReturnTo(window.location.search, API_ROOT, ['/oauth/login']));

  async function sendLink() {
    if (isLoading) return;
    isLoading = true;
    error = '';
    try {
      await authApi.requestAddressConfirmation();
      sent = true;
    } catch {
      error = $_('auth.verify.error');
    } finally {
      isLoading = false;
    }
  }

  async function signOut() {
    await logout();
    push('/login');
  }
</script>

<AuthCard title={$_('auth.verify.title')}>
  <p class="text-sm" style="color: var(--color-text-muted);" data-testid="verify-email-intro">
    {email ? $_('auth.verify.intro', { values: { email } }) : $_('auth.verify.introNoEmail')}
  </p>
  {#if resumesConsole}
    <p class="text-sm" style="color: var(--color-text-muted);" data-testid="verify-email-return">{$_('auth.verify.returnHint')}</p>
  {/if}
  {#if sent}
    <AuthNotice tone="success" testid="verify-email-sent">{$_('auth.verify.sent')}</AuthNotice>
  {/if}
  {#if error}
    <AuthNotice tone="error" testid="verify-email-error">{error}</AuthNotice>
  {/if}
  <button
    type="button"
    class="w-full btn btn-primary h-12 text-base"
    on:click={sendLink}
    disabled={isLoading}
    data-testid="verify-email-send"
  >
    {isLoading ? `${$_('common.loading')}...` : $_('auth.verify.send')}
  </button>
  <button type="button" class="w-full btn btn-secondary" on:click={signOut} data-testid="verify-email-logout">
    {$_('auth.verify.logout')}
  </button>
</AuthCard>
